import { FILTER_NAME_SUB_MENU } from '../../../constants/filter'
import {
  SUBMENU_DEFAULT_VALUE,
  SUBMENU_PARAM_ARCHIVE_VALUE,
} from '../../../constants/route'

export const CONTRACT_EXCLUDE_FILTERS = [FILTER_NAME_SUB_MENU]

// "All" / "Archive" sub-tabs (Confluence §3: `archive=false` / `archive=true`).
export const ENTITY_TAB_CONTRACTS_SUB_TAB_ORDER = [
  SUBMENU_DEFAULT_VALUE,
  SUBMENU_PARAM_ARCHIVE_VALUE,
]

export const ENTITY_TAB_CONTRACTS_SUB_TAB_TEXT_KEY = {
  [SUBMENU_DEFAULT_VALUE]: 'ContractTable.SubTabAllKey',
  [SUBMENU_PARAM_ARCHIVE_VALUE]: 'ContractTable.SubTabArchiveKey',
}

export const ENTITY_TAB_CONTRACTS_SUB_TAB_QA_NAME = {
  [SUBMENU_DEFAULT_VALUE]: 'entityTabContractsSubTabAll',
  [SUBMENU_PARAM_ARCHIVE_VALUE]: 'entityTabContractsSubTabArchive',
}

export const ENTITY_TAB_CONTRACTS_DEFAULT_QA_NAME = {
  addNew: 'entityTabContractsAddNew',
  table: 'entityTabContractsTable',
}

export const ENTITY_TAB_CONTRACTS_ITEM_ACTION = {
  Archive: 'archive',
  Edit: 'edit',
}

export const ENTITY_TAB_CONTRACTS_ITEM_ACTIONS = [
  {
    label: 'ContractTable.EditActionKey',
    value: ENTITY_TAB_CONTRACTS_ITEM_ACTION.Edit,
  },
  {
    label: 'ContractTable.ArchiveActionKey',
    value: ENTITY_TAB_CONTRACTS_ITEM_ACTION.Archive,
  },
]

export const CONTRACT_ITEM_ACTION_PERMISSION = {
  [ENTITY_TAB_CONTRACTS_ITEM_ACTION.Archive]: 'can_archive',
  [ENTITY_TAB_CONTRACTS_ITEM_ACTION.Edit]: 'can_edit',
}

export const CONTRACTS_MASS_ACTION_NAMES = {
  [ENTITY_TAB_CONTRACTS_ITEM_ACTION.Archive]: 'delete',
}
